import { Injectable } from "@angular/core";
import { AvisInitialTypeLight } from "../../models/AvisInitialTypeLight";

@Injectable({
    providedIn: 'root'
})
export class AvisInitialService {

    constructor() {
    }

    public getAvisInitial(controls): AvisInitialTypeLight {

        const avisInitial = new AvisInitialTypeLight();
        avisInitial.idWeb = controls.get('_SepSep_Annulation_SepSep_AvisInitialType_SepAtt_idWeb')

        avisInitial.datePublication = controls.get('_SepSep_Annulation_SepSep_AvisInitialType_SepAtt_datePublication')
            + controls.get('_SepSep_Annulation_SepSep_AvisInitialType_SepAtt_datePublication' + '_timestamp');
        
        return avisInitial;
    }
}